/* eslint-disable no-unused-expressions */
/* global G, PLATFORM */
import session from 'app/_shared/session'
import setAsRead from 'app/_shared/events/message/setAsRead'
import sequenceComponentFindProxy from 'lib/sequence/component/children/find'
import { isFn, setKey } from 'lib/util'

/**
 * @typedef {import('.').QuickPayload} QuickPayload
 */

/**
 * Returns the payload used to assign the ticket to the current user.
 *
 * @type QuickPayload
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {?Function} callback optional callback to fire after the patch
 * @returns {Promise<Object>}
 */
export default async (module, component, callback) => {
  const eventBus = module[G.ADAPTER][G.EVENTS]
  const assignee = session(module).user.key({ wrap: true })

  await setAsRead(module, component, null)

  eventBus.dispatch(eventBus.type(G.MESSAGE, G.SCROLL))

  return {
    value: {
      status: 50,
      statusReason: 0,
      postponeDate: null,
    },
    refs: {
      assignee,
    },
    ...isFn(callback) && { callback },
  }
}
